'use client';

import { Check } from 'lucide-react';
import { cn } from '@/shadcn/lib/utils';
import { TXN_TYPE_GROUPS } from '../../constants/filterConstants';
import type { AdvertTxnTypeOption } from '../../definitions/txnType';

interface Props {
    value: AdvertTxnTypeOption | null;
    onChange: (option: AdvertTxnTypeOption) => void;
}

/**
 * Obsah pulldownu "Typ inzeratu" - zoskupeny zoznam (Ponuka / Dopyt)
 * s jasnym oznacenim vybranej polozky.
 *
 * Zdielane medzi inline filtrom a rozsirenym dialogom, aby obe plochy
 * vyzerali a fungovali rovnako.
 */
export function TxnTypeOptions(props: Props) {
    return (
        <div className="w-full py-[2px]">
            {TXN_TYPE_GROUPS.map((group) => (
                <div key={group.label} className="mb-[6px] last:mb-0">
                    <p className="px-[12px] pt-[6px] pb-[4px] text-[11px] font-[700] uppercase tracking-[0.04em] text-black/40">
                        {group.label}
                    </p>
                    <ul className="w-full flex flex-col gap-[4px]">
                        {group.options.map((type) => {
                            // porovnanie cez slug - key nie je unikatny naprie skupinami
                            // (ponuka "Na Prenájom" aj dopyt "Hľadám Prenájom" su RENT)
                            const active = props.value?.slug === type.slug;
                            return (
                                <li
                                    key={type.slug}
                                    className={cn(
                                        'w-full flex items-center justify-between gap-[10px]',
                                        'text-[13px] font-[600] py-[10px] px-[12px] rounded-[12px] cursor-pointer',
                                        'transition duration-200 ease-[var(--ease-rx)]',
                                        active
                                            ? 'bg-[#f8ebb4] text-black'
                                            : 'text-black/80 hover:bg-[#f6f5f0] hover:text-black',
                                    )}
                                    onClick={() => props.onChange(type)}
                                >
                                    {type.value}
                                    <Check
                                        className={cn(
                                            'size-[16px] shrink-0 text-black',
                                            'transition duration-200 ease-[var(--ease-rx)]',
                                            active
                                                ? 'opacity-100 scale-100'
                                                : 'opacity-0 scale-75',
                                        )}
                                    />
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ))}
        </div>
    );
}
